module.exports = __webpack_public_path__ + "img/w23-b1.61df6ddd.jpg";